module.exports = __webpack_public_path__ + "modalOff-b45b778b943f96b590e9b7b6cd954d1d.png";